import { useNavigate } from "react-router-dom";

import logoutIcon from "../../images/logout.png";
import AuthService from "../../service/auth.service";
import styles from "./Logout.module.css";

const LogoutIcon = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    const logout = AuthService.logout();
    await navigate(-1).then(logout());
  };

  return (
    <div className={styles.back_icon}>
      <button onClick={handleLogout}>
        <img src={logoutIcon} alt="ícone de sair" width={50} height={50} />
      </button>
    </div>
  );
};

export default LogoutIcon;
